import React, { Suspense, lazy } from "react";
import { History } from "history";
import { ConnectedRouter } from "connected-react-router";
import { Dispatch } from "redux";
import IAction from "../models/IAction";
import LoadingIndicator from "./components/loading-indicator/LoadingIndicator";
import Toasts from "./components/toasts/Toasts";
import { Container } from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import ErrorViewer from "./components/error/ErrorViewer";
import BasePath from "./components/base-content/BasePath";
import Configuration from "./components/configuration/Configuration";

library.add(fas);

const MainNav = lazy(() => import("./components/main-nav/MainNav"));
const DiclaimerBanner = lazy(() => import("./components/disclaimer-banner/DiclaimerBanner"));

interface IProps {
    readonly history: History;
    readonly dispatch: Dispatch<IAction<any>>;
}
interface IState {}

export default class App extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        return (
            <ConnectedRouter history={this.props.history}>
                <Suspense fallback={<LoadingIndicator isActive={true} />}>
                    <MainNav />
                    <Toasts />
                    <Configuration />
                    <DiclaimerBanner />
                    <Container fluid className="p-0">
                        <ErrorViewer />
                        <BasePath />
                    </Container>
                    <div className="my-3"></div>
                </Suspense>
            </ConnectedRouter>
        );
    }
}
